import type { ParamType } from './ParamType';

export const getFromStorage = <T>(prop: ParamType | string): T | undefined => {
    if (!(window && window.localStorage)) return;

    const data = window.localStorage.getItem(prop) || '""';
    const result = JSON.parse(data);
    if (result !== undefined && result !== '') {
        return result as T;
    }
    return;
};
export const saveToStorage = <T>(prop: string, value: T) => {
    window.localStorage.setItem(prop, JSON.stringify(value));
};
export const clearStorage = (prop: string) => {
    window.localStorage.removeItem(prop);
};
